<script setup>
import NavigationMenu from '@/components/miscellaneous/NavigationMenu.vue'
</script>
<template>
    <div>
        <Header>
            <div class="top-navigation elevation-1 bg-blue-grey-darken-3">
                <v-container fluid class="d-flex align-center justify-space-between">
                    <div class="left d-flex align-center">
                        <span class="project-title text-h6"> &nbsp; </span>
                    </div>
                    <div class="center d-flex justify-center align-center flex-grow-1"></div>
                    <NavigationMenu />
                </v-container>
            </div>
        </Header>
        <slot />
        <Foot><LanguageSwitcher /></Foot>
    </div>
</template>
